export const siteContact = {
    name: "znanemiasto.pl",
    addressLine: "Plac Wolnica 14",
    postalCity: "31-060 Kraków",
    taxId: "6792975386",
    email: "kontakt@znanemiasto.pl",
    mapUrl: "https://www.google.com/maps/search/?api=1&query=Plac%20Wolnica%2014%2C%2031-060%20Krak%C3%B3w",
};